var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"output-message"},[(_vm.message.status !== 'loading')?_c('span',{staticClass:"code"},[_vm._v(_vm._s(_vm.message.data.input)+_vm._s(_vm.message.data.error || _vm.message.data.output))]):_c('loading-dot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }